/**
 * Can be used as additional visual layer for errors
 */

export const useAppShake = () => {
	const isShaking = useState('is-shaking-app', () => false);

	const start = () => {
		isShaking.value = true;
	};

	const stop = () => {
		isShaking.value = false;
	};

	return {
		isShaking: readonly(isShaking),
		start,
		stop,
	};
};
